import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { TrainingService } from '../services/training.service';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { LoadingController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { NetworkServiceService } from '../services/network-service.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit {
  eventList: any;
  data: any;
  title: string;
  description: string;
  location: string;
  heroImage: string;
  uid: string;
  userEmail: string;
  loading: any;
  error: string;
  networkList: any;
  materialList: any;
  baseUrl: string;
  eventMaterials: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public loadingController: LoadingController,
    private trainingService: TrainingService,
    private networkService: NetworkServiceService,
    private http: HttpClient
  ) {

    this.networkService.getNetwork().once('value', snapshot => {
      this.networkList = [];
      snapshot.forEach(snap => {
        if (snap.val().state === '1') {
          this.networkList.push({
            baseUrl: snap.val().base_url
          });
        }
      });
      this.baseUrl = this.networkList[0].baseUrl;
    });

    this.route.queryParams.subscribe(params => {
      this.eventList = [];
      if (this.router.getCurrentNavigation().extras.state) {
        this.data = this.router.getCurrentNavigation().extras.state.event.alias;
      }
    });

    this.error = '';
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.uid = user.uid;
        this.userEmail = user.email;
      }
    });
  }

  ngOnInit() {}

  async ionViewWillEnter() {
    // Present a loading controller until the data is loaded
    // await this.presentLoading();
    // Load the data
    this.prepareDataRequest()
        .pipe(
            finalize(async () => {
              // Hide the loading spinner on success or error
              // await this.loading.dismiss();
            })
        )
        .subscribe(
            data => {
              // Set the data to display in the template
              this.data = data;
            },
            err => {
              // Set the error information to display in the template
              this.error = `An error occurred, the data could not be retrieved: Status: ${err.status}, Message: ${err.statusText}`;
            }
        );
  }

  async presentLoading() {
    // Prepare a loading controller
    this.loading = await this.loadingController.create({
      message: 'Loading...'
    });
    // Present the loading controller
    await this.loading.present();
  }

  private prepareDataRequest(): Observable<object> {
    this.trainingService.getEvent(this.data).once('value', snapshot => {
      this.title = snapshot.val().title;
      this.description = snapshot.val().description;
      this.location = snapshot.val().location;
      this.heroImage = this.baseUrl + snapshot.val().heroimage;
      this.eventMaterials = this.getMaterials(snapshot.val().course_materials);
    });

    function attendeeSingle(attendee, email) {
      const attendeeList = attendee.split(',');
      for (let i = 0; i < attendeeList.length; i++) {
        if (attendeeList[i] === email) {
          return attendeeList[i];
          break;
        }
      }
    }
    return this.eventList;
  }

  getMaterials(materialString) {
    const materials = materialString.split(',');
    this.materialList = [];
    materials.forEach(material => {
      this.trainingService.getCourseMaterials().once('value', snapshot => {
        snapshot.forEach(snap => {
          if (material === snap.val().id.toString()) {
            this.materialList.push({
              title: snap.val().title,
              link: this.whichTypeOfLink(snap.val().link, snap.val().upload)
            });
          }
        });
      });
    });
    return this.materialList;
  }

  whichTypeOfLink(linkValue, uploadValue) {
    if(linkValue === '' || linkValue === null) {
      return this.baseUrl + 'images/training/' + uploadValue;
    } else {
      return linkValue;
    }
  }

  viewMaterials(link) {
    const courseMaterials = {
      link: link
    };

    const navigationExtras: NavigationExtras = {
      state: {
        materials: courseMaterials
      }
    };
    this.router.navigate(['course-materials'], navigationExtras);
  }

}
